import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Brightness1Icon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_1"}/>
}
